const let_8 = [
    "bouillon",
    "consomme",
    "dredging",
    "emulsion",
    "infusion",
    "kedgeree",
    "macerate",
    "mandolin",
    "emulsify",
    "julienne",
    "beetroot",
    "broccoli",
    "cucumber",
    "chopping",
    "cookbook",
    "whisking",
    "colander",
    "saucepan",
    "diabetes",
    "nutrient",
    "regulate",
    "delicacy",
    "artistry",
    "additive",
    "stinking",
    "sombrero",
    "nicotine",
    "molasses",
    "freshman",
    "luscious",
    "tasteful",
    "gourmand",
    "tortilla",
    "aromatic",
    "shepherd",
    "lamppost",
    "enhancer",
    "pimiento",
    "reserved",
    "pizzeria",
    "hostelry",
    "terrazzo",
    "glassful",
    "cocktail",
    "alfresco",
    "founding",
    "libation",
    "waitress",
    "monsieur",
    "broiling",
    "schnapps",
    "caffeine",
    "bakeshop",
    "purchase",
    "decadent",
    "balanced",
    "longhorn",
    "malarkey",
    "overcook",
    "potbelly",
    "elephant",
    "rickshaw",
    "original",
    "coleslaw",
    "mealtime",
    "charcoal",
    "handmade",
    "marinate",
    "leftover",
    "culinary",
    "baguette",
    "marigold",
    "espalier",
    "favorite",
    "document",
    "watering",
    "clambake",
    "plateful",
    "lifelong",
    "fireside",
    "arrogant",
    "oriental",
    "luncheon",
    "statuary",
    "sheeting",
    "suckling",
    "mesquite",
    "property",
    "quencher",
    "discount",
    "deadline",
    "sizzling",
    "paradise",
    "bleached",
    "tropical",
    "hazelnut",
    "lavender",
    "concerto",
    "barbecue",
    "allspice",
    "honeydew",
    "beetroot",
    "frosting",
    "meringue",
    "sunburst",
    "charcoal",
    "escarole",
    "capsicum",
    "shoulder",
    "dressing",
    "glycerin",
    "wishbone",
    "pimiento",
    "plantain",
    "walleyed",
    "cultured",
    "bouillon",
    "dripping",
    "zucchini",
    "crayfish",
    "snowshoe",
    "reserved",
    "coloring",
    "turnover",
    "elephant",
    "duckling",
    "drinking",
    "chessman",
    "porridge",
    "assorted",
    "battered",
    "peroxide",
    "pheasant",
    "macaroni",
    "enhancer",
    "browning",
    "unsifted",
    "cinnamon",
    "intrigue",
    "shanghai",
    "mushroom",
    "kohlrabi",
    "turmeric",
    "granular",
    "molasses",
    "chestnut",
    "boneless",
    "softener",
    "homemade",
    "hydrogen",
    "rapeseed",
    "zwieback",
    "angelica",
    "marigold",
    "mandarin",
    "pickerel",
    "bluefish",
    "stuffing",
    "cardamom",
    "flavored",
    "chloride",
    "anisette",
    "schnapps",
    "doughnut",
    "suddenly",
    "eggplant",
    "consomme",
    "favorite",
    "flounder",
    "imperial",
    "complete",
    "sprinkle",
    "sandwich",
    "goldfish",
    "meatless",
    "strength",
    "national",
    "licorice",
    "marinade",
    "ultimate",
    "lecithin",
    "unpeeled",
    "prepared",
    "squirrel",
    "shilling",
    "longhorn",
    "paraffin",
    "antelope",
    "rosemary",
    "whipping",
    "festival",
    "brandied",
    "albacore",
    "semolina",
    "heirloom",
    "fructose",
    "macaroon",
    "buttered",
    "seedless",
    "rutabaga",
    "tarragon",
    "spoonful",
    "absinthe",
    "seasoned",
    "amaranth",
    "straight",
    "uncooked",
    "lemonade",
    "beverage",
    "scallion",
    "speckled",
    "skinless",
    "mackerel",
    "powdered",
    "standing",
    "pastrami",
    "aluminum",
    "flexible",
    "southern",
    "northern",
    "laughing",
    "tamarind",
    "celeriac",
    "polished",
    "moisture",
    "geranium",
    "lollipop",
    "dumpling",

];

export default let_8;
